import { signInWithCustomToken, signInWithPopup } from 'firebase/auth';
import { Toast } from '../../../components/Common/Toast';
import { auth, provider } from '../../../firebase';
import { AppDispatch } from '../../../store/store';
import { setRedirectURL, setStudentTokenAuth } from '../../../store/userSlice';
import { callAPI } from '../../../services/api.service';
import { LocationType } from '../LocationSelection';
import { HTTPStatusEnum } from '../../../interfaces/log.interface';
import { encryptToken } from '../../../helper/helper';
import { autoFetchUserDetails } from '../../../store/thunks/user.thunk';
import { TokenCookieManager } from '../../../utils/tokenCookies';

export const handleStudentGoogleSignUp = async (
  setGoogleLoader: (loading: boolean) => void,
  dispatch: AppDispatch,
  navigateTo: (url: string) => void,
  location: LocationType | null | undefined = LocationType.Home,
) => {
  try {
    setGoogleLoader(true);
    const result: any = await signInWithPopup(auth, provider);

    const googleToken = await result?.user?.getIdToken();

    if (!googleToken) {
      Toast('Failed to get Google token', true);
      return;
    }

    // Call the student Google signin endpoint with token and location
    const response = await callAPI('api/auth/google/signInStudent', {
      googleToken,
      location,
    });

    if (response?.status !== HTTPStatusEnum.OK) {
      throw new Error('Failed to Login');
    }
    dispatch(setStudentTokenAuth(response.token));
    if (response.accepted) {
      const userCredential: any = await signInWithCustomToken(auth, response.token);
      // Encrypt the token
      const encryptedToken = encryptToken(userCredential?.user?.accessToken, process.env.REACT_APP_TOKEN_ENCRYPT_KEY!);

      // Store the token in cookies
      TokenCookieManager.setToken(encryptedToken);
      dispatch(setStudentTokenAuth(null));
      dispatch(autoFetchUserDetails());
      setTimeout(() => dispatch(setRedirectURL('/')), 250);
      return;
    } else {
      dispatch(setStudentTokenAuth(response.token));
      navigateTo('/auth/student/growup');
    }
  } catch (error: any) {
    if (error.code === 'auth/popup-closed-by-user') {
      return;
    }

    console.error('Student Google login error:', error);
    Toast('Something went wrong during student login', true);
  } finally {
    setGoogleLoader(false);
  }
};
